// @flow
import initialStore from '../initialStore';
import type { UserStore } from '../../types/user';
import type { UserAction } from '../../types/actions';

const userReducer = (state: UserStore = initialStore.user, action: UserAction): UserStore => {
  switch (action.type) {
  case 'USER_ERROR':
    return {
      ...state,
      loading: false,
      data: null,
      error: action.error
    };
  case 'SET_USER':
    return {
      ...state,
      loading: false,
      data: action.user,
      error: null
    };
  case 'LOAD_USER':
    return {
      ...state,
      loading: true
    };
  case 'POST_USER':
    return {
      ...state,
      loading: true
    };
  case 'RECEIVE_ID_CHECK':
    return {
      ...state,
      loading: false,
      idCheck: action.idCheck
    };
  case 'EMAIL_STATUS_UPDATED':
    return {
      ...state,
      emailCheckComplete: true
    };
  case 'POST_ADDRESS':
    return {
      ...state,
      loading: true
    };
  case 'REQUEST_USER':
    return {
      ...state,
      loading: true
    };
  case 'RECEIVE_USER':
    return {
      ...state,
      data: action.user,
      empty: action.empty,
      loading: false,
      error: null
    };
  case 'REDIRECTED':
    return {
      ...state,
      redirected: action.redirected
    };
  case 'SUBSCRIPTION_PAID':
    return {
      ...state,
      subscription: {
        paid: true
      }
    };
  default:
    return state;
  }
};

export default userReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/user.js